export enum WarningTypes {
  LowVisibility = 'lowVisibility',
  BrokenDownVehicle = 'brokenDownVehicle',
  VehicleAccident = 'accident',
  TractionLoss = 'tractionLoss',
  ConstructionSite = 'constructionSite',
  HeavyRain = 'heavyRain',
  HeavySnow = 'heavySnow',
  StrongWind = 'strongWind',
  PoorRoad = 'poorRoad',
  WrongWayDriver = 'wrongWayDriver',
  ItemOnRoad = 'itemOnRoad',
  AmberLightVehicle = 'amberLightVehicle',
  BlueLightVehicle = 'blueLightVehicle',
  StoppedVehicle = 'stoppedVehicle',
  TrafficJamTail = 'trafficJamTail',
}

export enum WarningDatasources {
  Cariad = 'warnings.cariad',
  Cariad_Acceptance = 'warnings.cariad_acceptance',
  Daimlertruck = 'warnings.daimlertruck',
  Daimlertruck_Acceptance = 'warnings.daimlertruck_acceptance',
  Rcs = 'warnings.rcs',
  Bmw = 'warnings.bmw',
  Bmw_Acceptance = 'warnings.bmw_acceptance',
  Intermediate = 'warnings.intermediate',
}

export enum TestWarningTypes {
  area = 'area',
  roadSegment = 'roadSegment',
}
